<template>
    <v-container class="icon-checkbox-container">
        <v-tooltip z-index="400" location="bottom" :max-width="200" :disable="hideTooltip">
            <template v-slot:activator="{ props }">
                <span v-bind="props">
                    <v-checkbox
                        :model-value="model"
                        class="rtls-checkbox"
                        :value="value"
                        :label="label"
                        :disabled="isDisabled || null"
                        :true-icon="'custom:' + icon"
                        :false-icon="'custom:' + icon"
                        :rules="rules"
                        :hide-details="hideDetails || null"
                        :validate-on="validateOn"
                        :true-value="trueValue"
                        @update:model-value="updateModel"
                    />
                </span>
            </template>
            <span>{{ toSentenceCase(tooltipLabel) }}</span>
        </v-tooltip>
    </v-container>
</template>

<script>
import vuexComponentMixin from '../../mixins/vuex-component';
import readonly from '@/js/mixins/readonly';

export default {
    mixins: [vuexComponentMixin, readonly],

    props: {
        hideDetails: {
            type: Boolean,
            default: true,
        },
        hideTooltip: {
            type: Boolean,
            default: false,
        },
        icon: String,
        tooltipLabel: String,
        value: {
            type: String,
            default: null,
        },
        validateOn: {
            type: String,
            default: 'blur',
        },
        trueValue: {
            type: [String, Boolean, Number],
            default: undefined,
        },
    },

    computed: {
        isDisabled() {
            return this.disabled || this.isReadOnly;
        },
    },

    methods: {
        /**
         * Update the model when checkbox state changes.
         * Handles array-based models for multiple checkboxes.
         * @param {Array} newValue - The new array value from the checkbox group
         */
        updateModel(newValue) {
            // Pass the entire updated array to the setter
            // The setter should handle the logic of what changed
            this.model = newValue;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';
@import '@style/base/_mixins.scss';

.icon-checkbox-container {
    .rtls-checkbox {
        :deep(.v-selection-control__input) {
            width: 2.4rem;
            height: 2.4rem;
            border: 0.1rem solid $promo-primary-colour;
            @include icon-border-radius;

            svg {
                height: 1.4rem;
                width: 1.4rem;
                bottom: 0.4rem;
                position: absolute;
            }

            input {
                z-index: 1;

                &[role='checkbox'] {
                    width: 2.5rem !important;
                    height: 2.5rem !important;
                }
            }

            .v-icon {
                opacity: 1;
                font-size: 1.2rem !important;
            }
        }
        :deep(.v-selection-control--dirty) {
            .v-selection-control__input {
                background-color: $promo-primary-colour;

                svg path,
                svg text {
                    fill: $promo-white;
                }
            }
        }

        :deep(.v-selection-control--error) {
            .v-selection-control__input {
                border-color: $vuetify-error-red;
            }
        }

        &.v-input--is-disabled {
            .v-input--selection-controls__input {
                border-color: $promo-grey-7;
                background-color: $promo-white;

                svg path,
                svg text {
                    fill: $promo-grey-7;
                }
            }
        }

        &.error--text {
            .v-input--selection-controls__input {
                border-color: $vuetify-error-red;

                svg path,
                svg text {
                    fill: $vuetify-error-red;
                }
            }
        }
    }

    &.v-input--is-label-active {
        .v-input--selection-controls__input {
            background-color: $promo-primary-colour;

            svg path,
            svg text {
                fill: $promo-white;
            }
        }

        &.v-input--is-disabled {
            .v-input--selection-controls__input {
                background-color: $promo-grey-7;

                svg path,
                svg text {
                    fill: $promo-white;
                }
            }
        }
    }
}
</style>
